module.exports = __webpack_public_path__ + "static/img/ttLogo.85438f72.png";